import React from 'react';

import { MainNavComponent as MainNav } from 'components/main-nav';

const styles = require('./header-component.styles.scss');


export class HeaderComponent extends React.Component {
  render() {
    return (
      <div className={styles.Header}>
        <MainNav className={styles.MainNav} />
        <div className={styles.MobileHeaderTitle}>
          Dr. Ann-Kathrin Fritsche
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/header/header.component.jsx